/**
 * usePageTitle Hook
 * Sets the document title for analytics tracking and browser tab display
 * Use this on pages that don't have the SEO component
 */

import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    const fullTitle = title.includes('Prozpector') ? title : `${title} | Prozpector`;
    document.title = fullTitle;
  }, [title]);
}
